import { subscribe, useSnapshot } from "valtio"
import { useEffect, useState } from "react"
import { AgmodalStore, bookingsStore, configStore, loginStore } from "../state/CommonState";
import TaskDatetime from "./task-datetime";
import Taskfileapproval, { validateFileApproval } from "./task-file-approval";
import Taskfiledisplay from "./task-file-display";
import Taskfiletable from "./task-file-table";
import { taskStore } from "./task-store";
import Taskapi from "./tasks-api";
import MonApi, { UPDATE_BOOKING_FIELDS_URI } from '../state/mongo-api';
async function callback(e) {
    taskStore.current.stage = 3
    taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
    taskStore.setComplete()
    taskStore.setCustomerComplete()
    await Taskapi.updateTask(taskStore.current)
    await MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
  _id: taskStore.current.bookingNum,
  blType: taskStore.current.blType
})
    taskStore.triggerActionVisible = false
    taskStore.myActionVisible = false
    if(AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()){
        AgmodalStore.pageVisible = false
        AgmodalStore.apiCall = true
    }
}
export default function BlTypeRequired(props) {
    useSnapshot(taskStore)
    useSnapshot(configStore)
    useSnapshot(AgmodalStore)
    let task = taskStore.current
    let stage = task.stage

    if (stage === 1) {
        return (
            <div className="box">
                <div>
                <label>We request you to kindly confirm whether you require a Seaway Bill of Lading or Originals to be released against this Booking</label>
                <br/>
                <div className="select" style={{paddingRight:'10px'}}>
                <select value={task.blType} onChange={(e) => {
                            task.blType = e.target.value
                }}>
                    <option value=''>Select</option>
                    <option value='Seaway'>Seaway</option>
                    <option value='Original'>Original</option>
                </select>
                </div>
                </div>
                <br/>
                <p>
                    <span>
                        <button style={{ float: 'left' }} disabled={task.blType==''} className="button islink"
                            onClick={callback}>Submit</button>
                    </span>
                </p>
            </div>
        )
    }
    if (stage >= 2) {
        return (
            <>
                <tr>
                    <td style={{ width: '20rem' }}>Type of BL:</td>
                    <td>
                        <strong>{task.blType}</strong>
                    </td>
                </tr>
                <br/>
                {/* <Taskfiledisplay /> */}
                <p>
                    <span>
                        {
                            (stage === 2) ?
                                <button style={{ float: 'right' }} className="button islink"
                                    onClick={async (e) => {
                                        //let task = taskStore.current
                                        task.stage = 3
                                        taskStore.setComplete()
                                        await Taskapi.updateTask(taskStore.current)
                                        taskStore.triggerActionVisible = false
                                        taskStore.myActionVisible = false
                                        if(AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()){
                                            AgmodalStore.pageVisible = false
                                            AgmodalStore.apiCall = true
                                        }
                                    }}>Acknowledge</button>
                                : <></>
                        }
                    </span>
                </p>
            </>
        )
    }
}
